import styled, { css } from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "Accordionstyles__Wrapper",
  componentId: "sc-1pskwpu-0"
})(["padding:", "px;", " ", ""], function (props) {
  return props.wrapperPadding >= 0 ? props.wrapperPadding : 13;
}, function (props) {
  return props.hasBorderTop && css(["border-top:1px solid ", ";"], props.theme.color.monochrome.light);
}, function (props) {
  return props.hasBorderBottom && css(["border-bottom:1px solid ", ";"], props.isOpen ? props.theme.color.monochrome.lighter : props.theme.color.monochrome.light);
});
var Title = styled.span.withConfig({
  displayName: "Accordionstyles__Title",
  componentId: "sc-1pskwpu-1"
})(["&&{margin:0;max-width:90%;}"]);
var Button = styled.button.withConfig({
  displayName: "Accordionstyles__Button",
  componentId: "sc-1pskwpu-2"
})(["display:flex;position:relative;width:100%;border:none;margin:0;padding:0;overflow:visible;background:transparent;color:inherit;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;appearance:none;text-align:left;", ""], function (props) {
  return props.disabled && css(["cursor:not-allowed;"]);
});
var ButtonLink = styled.button.withConfig({
  displayName: "Accordionstyles__ButtonLink",
  componentId: "sc-1pskwpu-3"
})(["display:block;border:none;margin-top:6px;padding:0;overflow:visible;background:transparent;appearance:none;text-align:left;color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";text-decoration:underline;&:hover,&:active,&:focus{color:", ";}"], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.font.family['label-1'];
}, function (props) {
  return props.theme.font.weight['label-1'];
}, function (props) {
  return props.theme.font.size['label-1'];
}, function (props) {
  return props.theme.font['line-height']['label-1'];
}, function (props) {
  return props.theme.color.alias.link.hover.color;
});
var ButtonAll = styled(ButtonLink).withConfig({
  displayName: "Accordionstyles__ButtonAll",
  componentId: "sc-1pskwpu-4"
})(["width:100%;text-align:right;margin-bottom:10px;"]);
var Toggle = styled.span.withConfig({
  displayName: "Accordionstyles__Toggle",
  componentId: "sc-1pskwpu-5"
})(["position:absolute;right:0;top:2px;cursor:pointer;transition:0.2s ease;", ""], function (props) {
  return props.isOpen && css(["top:-2px;transform:rotate(180deg);"]);
});
var Container = styled.div.withConfig({
  displayName: "Accordionstyles__Container",
  componentId: "sc-1pskwpu-6"
})(["overflow:hidden;", " ", ""], function (props) {
  return css(["max-height:", ";font-family:", ";font-size:", ";visibility:", ";"], props.maxHeight, props.theme.font.family.base, props.theme.font.size.base, props['aria-hidden'] ? 'hidden' : 'visible');
}, function (props) {
  return !props.noAnimation && css(["transition:max-height 0.2s ease-out;"]);
});
var InnerContainer = styled.div.withConfig({
  displayName: "Accordionstyles__InnerContainer",
  componentId: "sc-1pskwpu-7"
})(["margin-top:", "px;"], function (props) {
  return props.titleBodySpacing >= 0 ? props.titleBodySpacing : 15;
});
export { Wrapper, Title, Button, ButtonLink, ButtonAll, Toggle, Container, InnerContainer };